// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SkypeFilledSvg from "@fishx/icons-svg/es/asn/SkypeFilled";
import FishxIcon from '../components/FishxIcon';

var SkypeFilled = function SkypeFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SkypeFilledSvg
  }));
};

SkypeFilled.displayName = 'SkypeFilled';
export default React.forwardRef(SkypeFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SkypeFilled.js
// module id = 4138
// module chunks = 0